import TestimonialItem from "./Item";
import Title from "../Common/Title";
import Carousel from "../Common/carousel/Carousel";
import { useTranslation } from "react-i18next";

// local images
import alfredoPic from '../../assets/images/testimonials/Alfredo Mendez Rodriguez.webp';
import jorgePic from '../../assets/images/testimonials/Jorge Luis Martin Murry.webp';
import victorPic from '../../assets/images/testimonials/Victor Gonzalez.webp';
import idalvisPic from '../../assets/images/testimonials/Idalvis Chacon.webp';
import brunoPic from '../../assets/images/testimonials/Bruno Garcia Switch.webp';
import marianaPic from '../../assets/images/testimonials/Mariana Lourdes Masvidal Guirola.webp';

const testimonials = [
  {
    body: "No puedo estar más contento con el servicio de recargas telefónicas! Siempre que necesito recargar el teléfono de mis familiares, este equipo es mi salvador. Son rápidos, confiables y ofrecen tarifas excelentes. ¡Gracias por mantenernos conectados de una manera tan eficiente y accesible! Recomiendo encarecidamente este servicio a todos los que deseen enviar recargas de manera fácil y segura. 🚀🔐💪",
    rating: 5,
    author: {
      name: "Alfredo Mendez Rodriguez",
      handle: "amendez9216",
      imageUrl: alfredoPic,
    },
  },
  {
    body: "Su puntualidad y Seriedad con los Clientes",
    rating: 5,
    author: {
      name: "Jorge Luis Martin Murry",
      imageUrl: jorgePic,
    },
  },

  {
    body: 'Super recomiendo !! El mejor servicio para poner saldo en el móvil',
    rating: 5,
    author: {
      name: 'Mariana Lourdes Masvidal Guirola',
      handle: 'mariana.masvidalguirola',
      imageUrl: marianaPic
    }
  },
  {
    body: "Excelente el servicio. La recarga llego sin ningun tipo de problemas. Repetire!!",
    rating: 5,
    author: {
      name: "Victor Gonzalez",
      handle: "victor.m.gonzalezsalazar",
      imageUrl: victorPic,
    },
  },
  {
    body: 'muy util y rápido te lo aconsejo',
    rating: 5,
    author: {
      name: 'Idalvis Chacón',
      handle: 'idalvis.chacon',
      imageUrl: idalvisPic
    }
  },
  {
    body: 'Excelente plataforma para recargar celulares. Hasta ahora la más económica que he encontrado y la recarga llegó perfectamente !!!',
    rating: 5,
    author: {
      name: 'Bruno García Switch',
      handle: 'bruno.garciaswitch.7',
      imageUrl: brunoPic
    }
  }
];

export default function TestimonialList() {
  const { t } = useTranslation();

  return (
    <div className="bg-white py-10 sm:py-24 mt-20 md:mt-32">
      <div className="mx-auto max-w-7xl px-0 md:px-6 lg:px-8">
        <Title color title={t('testimonials.title')} className="mx-4 md:mx-0 text-center md:text-left font-brave-hunter" fontWeight='medium'/>
        <div className="mx-auto max-w-2xl lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 lg:max-w-none lg:grid-cols-1 mx-auto">
            <Carousel items={testimonials.map((feature) => (
              <TestimonialItem key={feature.author.handle} item={feature} />
            ))} />
          </dl>
        </div>
      </div>
    </div>
  );
}
